import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 20.949a1.63 1.63 0 0 0 1.577-1.393H9.362A1.63 1.63 0 0 0 11 20.949M17.509 11.838a6.5 6.5 0 0 1-1.223.075v.37a8.7 8.7 0 0 0 1.009 3.575 10 10 0 0 0 1.49 1.834H3.136a10 10 0 0 0 1.491-1.834 8.7 8.7 0 0 0 1.009-3.575V9.258a5.38 5.38 0 0 1 4.648-5.352c.238-.93.68-1.78 1.274-2.497a.82.82 0 0 0-.652-.324.816.816 0 0 0-.815.816v.8a6.606 6.606 0 0 0-5.684 6.557v3.02a7.7 7.7 0 0 1-.825 2.939 8.8 8.8 0 0 1-1.51 1.79.61.61 0 0 0-.207.458v.832a.61.61 0 0 0 .611.61h16.989a.61.61 0 0 0 .611-.61v-.832a.61.61 0 0 0-.208-.458 8.8 8.8 0 0 1-1.533-1.79 7.7 7.7 0 0 1-.825-2.94z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      d: "M16.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11",
      style: {"fill":"var(--danger)"}
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }